import CheckIcon from '@/assets/icons/api-integration/check.svg?react'
import SparklesIcon from '@/assets/icons/api-integration/sparkles.svg?react'
import ShieldIcon from '@/assets/icons/api-integration/shield.svg?react'
import StarIcon from '@/assets/icons/api-integration/star.svg?react'

export const options = [
  {
    label: 'Real-time data sync',
    icon: CheckIcon
  },
  {
    label: 'Enhanced customization',
    icon: SparklesIcon
  },
  {
    label: 'Effortless workflow integration',
    icon: ShieldIcon
  },
  {
    label: 'Scalability and future-readiness',
    icon: StarIcon
  }
]